import { render, staticRenderFns } from "./CourseNew.vue?vue&type=template&id=70ad0bfe&"
import script from "./CourseNew.vue?vue&type=script&lang=ts&"
export * from "./CourseNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports